exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".generic-observation-no-data-device-link{margin:0 40px}.generic-observation-no-data-device-link svg{margin-bottom:20px}.generic-observation-no-data-device-link .message svg{margin:0px;vertical-align:middle}", ""]);

